// extracted by mini-css-extract-plugin
export default {"btn":"style_btn__YsKPR","hasBackground":"style_hasBackground__AgjUp","noBackground":"style_noBackground__+jaaZ","primaryBorder":"style_primaryBorder__yFUup"};